import { css } from '@emotion/react'

import useLayoutContext from '@/components/Layout/useLayoutContext'

// Use this to wrap sections of a page that you'd like to be able to link
// to using `www.link.com#section`. It takes care of adjusting for the
// height of the navbar.
export default function LinkableDiv({
  id,
  children,
}: {
  id: string
  children?: React.ReactNode
}): JSX.Element {
  const { navbarOffsetPx } = useLayoutContext()
  return (
    <div
      id={id}
      css={css`
        scroll-margin-top: ${navbarOffsetPx};
      `}
    >
      {children}
    </div>
  )
}
